import React from 'react'
import PropTypes from 'prop-types'
import { JobCard } from '../JobCard'
import css from './Jobs.module.css'

const Jobs = ({ jobs }) => (
  <div className={css.jobsWrapper}>
    {(!!jobs.length && jobs.map((job, index) => (
      <JobCard
        jobTitle={job.name}
        department={job.department}
        jobURL={job.ref}
        key={job.id}
        hasGreyBackground={index % 2 !== 0}
      />
    )))}
  </div>
)

Jobs.propTypes = {
  jobs: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
}

export { Jobs }
